// Tiny dev-gated logger.
//
// Rationale: static-analysis code-review tools flag `console.*` in production
// bundles as noise / potential info-leakage.  React's default `react-scripts`
// build already strips no console statements, so we manually gate them behind
// NODE_ENV so they stay useful in preview/dev and disappear in the production
// bundle.  Errors that must reach real monitoring should be routed through a
// dedicated error-tracking service (Sentry, etc.) — kept as a TODO here since
// no key has been provisioned yet.

const isDev =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

export const logger = {
  error: (...args) => {
    if (isDev) {
      console.error(...args);
    }
    // TODO: forward to Sentry / logging service once configured.
  },
  warn: (...args) => {
    if (isDev) {
      console.warn(...args);
    }
  },
};
